import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class CompaniesService {

    constructor(private http: HttpClient) { }

    getCompany(slug, params?): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/products/vendor/${slug}`, { params });
    }

    getCompanyTerms(slug, params?): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/companies/terms/${slug}`, { params });
    }
    getCompanies(params): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/companies/`, { params });
    }

    getStoresByCountry(params): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/companies/country/`, { params });
    }

    getgallery(params): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/companies/gallery`, { params });
    }

    getCompanyName(slug: string): Observable<{en:string, ar?: string}> {
        return this.http.get<any>(`${environment.apiUrl}/companies/name/${slug}`).pipe(
            map(response => response.data.name || { en: '', ar: '' }),
            catchError(() => of({ en: '', ar: '' })) 
        );
    }
}


